export default {
  Aircrafts__UNKNOWN_EQUIPMENT: "N/A",
};
